import * as React from 'react'
import { FC, useCallback, useState } from 'react'
import { DeleteConfirmation } from './DeleteConfirmation'
import { BulkActionButton } from '../BulkActionButton'
import { useBulkActionContext } from '../BulkActionContext'

import { useGridApiContext } from '@mui/x-data-grid-pro'
import Dialog from '@mui/material/Dialog'

type Props = {
  recordCount: number
  saveCallback: () => Promise<boolean>
  hasPermission: boolean
}

export const BulkDelete: FC<Props> = (props) => {
  const { saveCallback, hasPermission } = props

  const apiRef = useGridApiContext()
  const { dispatch } = useBulkActionContext()

  const [open, setOpen] = useState(false)
  const [saving, setSaving] = useState(false)

  const onOpen = useCallback(() => {
    setOpen(true)
    dispatch({ type: 'setActive', payload: 'delete' })
  }, [dispatch])

  const onClose = useCallback(() => {
    if (!saving) {
      setOpen(false)
      dispatch({ type: 'setActive' })
    }
  }, [dispatch, saving])

  const onSave = useCallback(async () => {
    setSaving(true)
    const success = await saveCallback()

    if (!success) {
      setSaving(false)
    } else {
      apiRef?.current.setRowSelectionModel([])
    }
  }, [apiRef, saveCallback])

  return (
    <>
      <BulkActionButton
        onClick={onOpen}
        type="delete"
        helperText="Mass delete records. This action cannot be undone or recovered."
        hasPermission={hasPermission}
        errorString="You do not have permissions to perform bulk deletes."
      >
        Delete
      </BulkActionButton>

      <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
        <DeleteConfirmation
          {...props}
          saving={saving}
          onSaveClick={onSave}
          onCancelClick={onClose}
        />
      </Dialog>
    </>
  )
}
BulkDelete.displayName = 'BulkDelete'
